const e = (...o) => o.filter(Boolean).join(" ");
export {
  e as clx
};
